export default __webpack_public_path__ + "static/media/sign_up_middle_down2.17432db2.png";